import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#F8FAFB]">
      {/* Header */}
      <header className="bg-white border-b border-[#E5E7EB] sticky top-0 z-50 backdrop-blur-lg bg-white/95">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img 
                src="https://public.readdy.ai/ai/img_res/242a1403-cfd7-49be-b11f-231711dbad5d.png" 
                alt="LeadSystem Logo" 
                className="h-8 w-auto object-contain"
              />
              <span className="text-2xl font-bold text-[#0F766E]" style={{ fontFamily: 'Georgia, serif' }}>
                LeadSystem
              </span>
            </Link>
            <Link 
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 text-[#0F766E] hover:bg-[#E0F2F1] rounded-full transition-all font-semibold cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl md:text-6xl font-bold text-[#2C3E50] mb-8" style={{ fontFamily: 'Georgia, serif' }}>
            Impressum
          </h1>

          <div className="bg-white rounded-3xl shadow-lg border border-[#E5E7EB] p-10 space-y-10">
            {/* Angaben gemäß § 5 TMG */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Angaben gemäß § 5 TMG</h2>
              <div className="text-[#374151] space-y-2 leading-relaxed">
                <p className="font-semibold text-[#2C3E50]">Future Now UG (haftungsbeschränkt)</p>
                <p>Max-Planck-Str. 4</p>
                <p>85609 Aschheim</p>
                <p>Deutschland</p>
              </div>
            </section>

            {/* Vertreten durch */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Vertreten durch</h2>
              <p className="text-[#374151]">Geschäftsführer: Olaf Niggemann</p>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Kontakt</h2>
              <div className="text-[#374151] space-y-2">
                <p>
                  <span className="font-semibold text-[#2C3E50]">E-Mail:</span>{' '}
                  <a href="mailto:info@future-now.online" className="text-[#0F766E] hover:underline">
                    info@future-now.online
                  </a>
                </p>
              </div>
            </section>

            {/* Registereintrag */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Registereintrag</h2>
              <div className="text-[#374151] space-y-2">
                <p><span className="font-semibold text-[#2C3E50]">Eintragung im Handelsregister:</span></p>
                <p>Registergericht: Amtsgericht München</p>
                <p>Registernummer: HRB [Registernummer]</p>
              </div>
            </section>

            {/* Umsatzsteuer-ID */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Umsatzsteuer-ID</h2>
              <div className="text-[#374151] space-y-2">
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
                </p>
                <p>DE [USt-IdNr.]</p>
              </div>
            </section>

            {/* Verantwortlich für den Inhalt */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <div className="text-[#374151] space-y-2">
                <p>Olaf Niggemann</p>
                <p>Max-Planck-Str. 4</p>
                <p>85609 Aschheim</p>
              </div>
            </section>

            {/* EU-Streitschlichtung */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">EU-Streitschlichtung</h2>
              <p className="text-[#374151] leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#0F766E] hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                <br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            {/* Verbraucherstreitbeilegung */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
              <p className="text-[#374151] leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            {/* Haftungsausschluss */}
            <section>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Haftungsausschluss</h2>
              
              <h3 className="text-xl font-semibold text-[#2C3E50] mb-3 mt-6">Haftung für Inhalte</h3>
              <p className="text-[#374151] leading-relaxed mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-[#374151] leading-relaxed">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>

              <h3 className="text-xl font-semibold text-[#2C3E50] mb-3 mt-6">Haftung für Links</h3>
              <p className="text-[#374151] leading-relaxed mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
              <p className="text-[#374151] leading-relaxed">
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h3 className="text-xl font-semibold text-[#2C3E50] mb-3 mt-6">Urheberrecht</h3>
              <p className="text-[#374151] leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
            </section>
          </div>

          {/* Back to Home */}
          <div className="mt-12 text-center">
            <Link 
              to="/"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#14B8A6] text-white rounded-full hover:bg-[#0D9488] transition-all hover:shadow-xl font-semibold cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Zurück zur Startseite
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
